import { useState } from "react";
import useScrollTo from "../../hooks/useScrollTo";

const genderOptions = ["Male", "Female", "Other"];

const livingOptions = [
  "Me",
  "Other parent",
  "Shared 50/50",
  "Grandparents",
  "Other",
];

const SecondChild = ({ state, dispatch }) => {
  const [childSecondName, setChildSecondName] = useState(
    state.childSecondName || ""
  );
  const [childSecondFamilyName, setChildSecondFamilyName] = useState(
    state.childSecondFamilyName || ""
  );
  const [childSecondGender, setChildSecondGender] = useState(
    state.childSecondGender
  );

  const childSecondGenderOptions = genderOptions.map((value, idx) => (
    <option value={value} key={idx}>
      {value}
    </option>
  ));

  const [childSecondLiving, setChildSecondLiving] = useState(
    state.childSecondLiving
  );

  const childSecondLivingOptions = livingOptions.map((value, idx) => (
    <option value={value} key={idx}>
      {value}
    </option>
  ));

  const [childSecondDoB, setChildSecondDoB] = useState(
    state.childSecondDoB || ""
  );
  const [childSecondIssues, setChildSecondIssues] = useState(
    state.childSecondIssues
  );
  const [childSecondNeeds, setChildSecondNeeds] = useState(
    state.childSecondNeeds || ""
  );
  const [
    childSecondParentalResponsibility,
    setChildSecondParentalResponsibility,
  ] = useState(state.childSecondParentalResponsibility);
  const [checkThirdChild, setCheckThirdChild] = useState(state.checkThirdChild);

  useScrollTo(0, 0, "smooth");

  const onCheckThirdChild = ({ target }) => {
    setCheckThirdChild(target.value);
    dispatch({ type: "THIRD_CHILD_CHECK", payload: target.value });
  };

  const onSecondNameChange = ({ target }) => {
    setChildSecondName(target.value);
    dispatch({ type: "SECOND_CHILD_FIRST_NAME", payload: target.value });
  };

  const onFamilyNameChange = ({ target }) => {
    setChildSecondFamilyName(target.value);
    dispatch({ type: "SECOND_CHILD_FAMILY_NAME", payload: target.value });
  };

  const onGenderChange = ({ target }) => {
    setChildSecondGender(target.value);
    dispatch({ type: "SECOND_CHILD_GENDER", payload: target.value });
  };

  const onLivingChange = ({ target }) => {
    setChildSecondLiving(target.value);
    dispatch({ type: "SECOND_CHILD_LIVING", payload: target.value });
  };

  const onDoBChange = ({ target }) => {
    setChildSecondDoB(target.value);
    dispatch({ type: "SECOND_CHILD_DAY_OF_BIRTH", payload: target.value });
  };

  const onIssuesChange = ({ target }) => {
    setChildSecondIssues(target.value);
    dispatch({ type: "SECOND_CHILD_ISSUE", payload: target.value });
  };

  const onNeedsChange = ({ target }) => {
    setChildSecondNeeds(target.value);
    dispatch({ type: "SECOND_CHILD_NEEDS", payload: target.value });
  };

  const onParentalResponsibilityChange = ({ target }) => {
    setChildSecondParentalResponsibility(target.value);
    dispatch({ type: "SECOND_CHILD_RESPONSIBILITY", payload: target.value });
  };

  return (
    <div>
      <h2>The Second child's details</h2>
      <div className="d-flex m-25" style={{ alignItems: "flex-end" }}>
        <div>
          <label htmlFor="first-child-first-name">
            What is the first name of the second child?
            <span className="color-red">*</span>
          </label>
          <input
            type="text"
            id="first-child-first-name"
            value={childSecondName}
            onChange={onSecondNameChange}
            required
          />
        </div>
        <div className="mt-20">
          <label htmlFor="first-child-family-name">
            What is {childSecondName}'s surname/family name?
            <span className="color-red">*</span>
          </label>
          <input
            type="text"
            id="first-child-family-name"
            value={childSecondFamilyName}
            onChange={onFamilyNameChange}
            required
          />
        </div>
      </div>
      <div className="m-25">
        <label>
          What is {childSecondName}'s gender?
          <span className="color-red">*</span>
        </label>
        <select value={childSecondGender} onChange={onGenderChange} required>
          <option value="select">--- Select An Option ---</option>
          {childSecondGenderOptions}
        </select>
      </div>
      <div className="m-25">
        <label>
          Who is {childSecondName} living with mostly?
          <span className="color-red">*</span>
        </label>
        <select value={childSecondLiving} onChange={onLivingChange} required>
          <option value="select">--- Select An Option ---</option>
          {childSecondLivingOptions}
        </select>
      </div>
      <div className="d-flex col-flex m-25">
        <label htmlFor="first-child-day-of-birth">
          What is {childSecondName}'s date of birth?
          <span className="color-red">*</span>
        </label>
        <p className="guide-label">
          In case you don't know, please type N/K in the box below.
        </p>
        <input
          type="text"
          id="first-child-day-of-birth"
          value={childSecondDoB}
          onChange={onDoBChange}
          required
        />
      </div>
      <div className="m-25">
        <label>
          Does {childSecondName} have any special needs or health issues?
          <span className="color-red">*</span>
        </label>
        <div className="radio-style">
          <label htmlFor="yesNeeds" className="label-control">
            <input
              type="radio"
              name="needs"
              id="yesNeeds"
              required
              value="Yes"
              onChange={onNeedsChange}
              checked={childSecondNeeds === "Yes"}
            />
            Yes
          </label>
          <label htmlFor="noNeeds" className="label-control">
            <input
              type="radio"
              name="needs"
              id="noNeeds"
              value="No"
              onChange={onNeedsChange}
              checked={childSecondNeeds === "No"}
            />
            No
          </label>
        </div>
      </div>
      {childSecondNeeds === "Yes" && (
        <div className="d-flex col-flex m-25">
          <label htmlFor="first-child-issues">
            What special needs or health issues does {childSecondName} have?
            <span className="color-red">*</span>
          </label>
          <input
            type="text"
            id="first-child-issues"
            style={{ width: "95%" }}
            value={childSecondIssues}
            onChange={onIssuesChange}
            required
          />
        </div>
      )}
      <div className="m-25">
        <label>
          Do you have parental responsibility of {childSecondName}?
          <span className="color-red">*</span>
        </label>
        <div className="radio-style">
          <label htmlFor="yesParental" className="label-control">
            <input
              type="radio"
              name="parental"
              id="yesParental"
              required
              value="Yes"
              onChange={onParentalResponsibilityChange}
              checked={childSecondParentalResponsibility === "Yes"}
            />
            Yes
          </label>
          <label htmlFor="noParental" className="label-control">
            <input
              type="radio"
              name="parental"
              id="noParental"
              value="No"
              onChange={onParentalResponsibilityChange}
              checked={childSecondParentalResponsibility === "No"}
            />
            No
          </label>
        </div>
      </div>
      <div className="m-25">
        <label>
          Is there a third child that you wish to include in your discussions in
          mediation?<span className="color-red">*</span>
        </label>
        <div className="radio-style">
          <label htmlFor="yesDiscussions" className="label-control">
            <input
              type="radio"
              name="discussions"
              id="yesDiscussions"
              required
              value="Yes"
              onChange={onCheckThirdChild}
              checked={checkThirdChild === "Yes"}
            />
            Yes
          </label>
          <label htmlFor="noDiscussions" className="label-control">
            <input
              type="radio"
              name="discussions"
              id="noDiscussions"
              value="No"
              onChange={onCheckThirdChild}
              checked={checkThirdChild === "No"}
            />
            No
          </label>
        </div>
      </div>
    </div>
  );
};

export default SecondChild;
